import { call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import { passwordChangeError } from '../actions/changePassword';
import { changeResetPassword } from '../api/index';

export function* changePassword({ payload }) {
  try {
    yield call(changeResetPassword, payload);
    yield put(push('/login'));
  } catch (e) {
    // surfaces the failure in the form and re-enables the submit button
    yield put(passwordChangeError(e?.response?.data?.message));
  }
}
